// src/types/auth.ts
var SessionActions = /* @__PURE__ */ ((SessionActions2) => {
  SessionActions2["REGISTER"] = "register";
  SessionActions2["DEPOSIT"] = "deposit";
  SessionActions2["WITHDRAW"] = "withdraw";
  SessionActions2["APPROVE_MILESTONE"] = "approve_milestone";
  SessionActions2["FUND_MILESTONE"] = "fund_milestone";
  SessionActions2["SUBMIT_DELIVERY"] = "submit_delivery";
  SessionActions2["PAY_MILESTONE"] = "pay_milestone";
  SessionActions2["PAY_DIRECT"] = "pay_direct";
  SessionActions2["DISPUTE_MILESTONE"] = "dispute_milestone";
  SessionActions2["UPLOAD_AGREEMENT"] = "upload_agreement";
  SessionActions2["UPLOAD_DOCUMENTS"] = "upload_documents";
  SessionActions2["PROVIDE_USER_DATA"] = "provide_user_data";
  SessionActions2["PROPOSE_PAYMENT_SPLIT"] = "propose_payment_split";
  SessionActions2["APPROVE_OR_REJECT_PAYMENT_SPLIT"] = "approve_or_reject_payment_split";
  SessionActions2["ADD_WALLET_OWNER"] = "add_wallet_owner";
  SessionActions2["REMOVE_WALLET_OWNER"] = "remove_wallet_owner";
  SessionActions2["RESOLVE_DISPUTE"] = "resolve_dispute";
  return SessionActions2;
})(SessionActions || {});
var SessionUserType = /* @__PURE__ */ ((SessionUserType2) => {
  SessionUserType2["CLIENT_USER"] = "client-user";
  SessionUserType2["TENANT_USER"] = "tenant-user";
  SessionUserType2["ROOT_ADMIN"] = "root-admin";
  return SessionUserType2;
})(SessionUserType || {});
var PasskeyResponseType = /* @__PURE__ */ ((PasskeyResponseType2) => {
  PasskeyResponseType2["REGISTRATION"] = "registration";
  PasskeyResponseType2["AUTHENTICATION"] = "authentication";
  return PasskeyResponseType2;
})(PasskeyResponseType || {});

// src/types/api-errors.ts
var ApiErrorCode = /* @__PURE__ */ ((ApiErrorCode2) => {
  ApiErrorCode2["UNKNOWN"] = "UNKNOWN";
  ApiErrorCode2["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
  ApiErrorCode2["DEPRECATED"] = "DEPRECATED";
  ApiErrorCode2["BAD_REQUEST"] = "BAD_REQUEST";
  ApiErrorCode2["UPSTREAM_ERROR"] = "UPSTREAM_ERROR";
  ApiErrorCode2["UPSTREAM_AUTH_ERROR"] = "UPSTREAM_AUTH_ERROR";
  ApiErrorCode2["CHALLENGE_NOT_FOUND"] = "CHALLENGE_NOT_FOUND";
  ApiErrorCode2["SESSION_NOT_FOUND"] = "SESSION_NOT_FOUND";
  ApiErrorCode2["INVALID_PASSKEY_RESPONSE_TYPE"] = "INVALID_PASSKEY_RESPONSE_TYPE";
  ApiErrorCode2["INVALID_SESSION_ACTION"] = "INVALID_SESSION_ACTION";
  ApiErrorCode2["INVALID_INVITATION"] = "INVALID_INVITATION";
  ApiErrorCode2["INVITATION_EXPIRED"] = "INVITATION_EXPIRED";
  ApiErrorCode2["INVITATION_NOT_FOUND"] = "INVITATION_NOT_FOUND";
  ApiErrorCode2["UNAUTHORIZED"] = "UNAUTHORIZED";
  ApiErrorCode2["SESSION_REVOKED"] = "SESSION_REVOKED";
  ApiErrorCode2["ACCOUNT_NOT_DEPLOYED"] = "ACCOUNT_NOT_DEPLOYED";
  ApiErrorCode2["CONTEXT_HEADER_NOT_FOUND"] = "CONTEXT_HEADER_NOT_FOUND";
  ApiErrorCode2["CONTEXT_NOT_ACTIVE"] = "CONTEXT_NOT_ACTIVE";
  ApiErrorCode2["CONTEXT_INVALID"] = "CONTEXT_INVALID";
  ApiErrorCode2["CONTEXT_NOT_FOUND"] = "CONTEXT_NOT_FOUND";
  ApiErrorCode2["TENANT_NOT_FOUND"] = "TENANT_NOT_FOUND";
  ApiErrorCode2["TENANT_MISMATCH"] = "TENANT_MISMATCH";
  ApiErrorCode2["TENANT_BRIDGE_NOT_SETUP"] = "TENANT_BRIDGE_NOT_SETUP";
  ApiErrorCode2["TENANT_BRIDGE_WEBHOOK_ALREADY_SETUP"] = "TENANT_BRIDGE_WEBHOOK_ALREADY_SETUP";
  ApiErrorCode2["TENANT_BRIDGE_WEBHOOK_NOT_FOUND"] = "TENANT_BRIDGE_WEBHOOK_NOT_FOUND";
  ApiErrorCode2["TENANT_BRIDGE_WEBHOOK_SHARED_MODE"] = "TENANT_BRIDGE_WEBHOOK_SHARED_MODE";
  ApiErrorCode2["TENANT_BRIDGE_WEBHOOK_NOT_CONFIGURED"] = "TENANT_BRIDGE_WEBHOOK_NOT_CONFIGURED";
  ApiErrorCode2["TENANT_ADDRESS_NOT_CONFIGURED"] = "TENANT_ADDRESS_NOT_CONFIGURED";
  ApiErrorCode2["CLIENT_USER_NOT_FOUND"] = "CLIENT_USER_NOT_FOUND";
  ApiErrorCode2["CLIENT_USER_NOT_REGISTERED_WITH_PROVIDER"] = "CLIENT_USER_NOT_REGISTERED_WITH_PROVIDER";
  ApiErrorCode2["CLIENT_USER_ALREADY_SIGNED_TOS"] = "CLIENT_USER_ALREADY_SIGNED_TOS";
  ApiErrorCode2["CLIENT_USER_NOT_SIGNED_TOS"] = "CLIENT_USER_NOT_SIGNED_TOS";
  ApiErrorCode2["CLIENT_USER_EMAIL_ALREADY_EXISTS"] = "CLIENT_USER_EMAIL_ALREADY_EXISTS";
  ApiErrorCode2["CLIENT_USER_EMAIL_ALREADY_REGISTERED"] = "CLIENT_USER_EMAIL_ALREADY_REGISTERED";
  ApiErrorCode2["CLIENT_USER_KIND_MISMATCH"] = "CLIENT_USER_KIND_MISMATCH";
  ApiErrorCode2["API_KEY_NOT_FOUND"] = "API_KEY_NOT_FOUND";
  ApiErrorCode2["WEBHOOK_NOT_FOUND"] = "WEBHOOK_NOT_FOUND";
  ApiErrorCode2["WEBHOOK_SEND_FAILED"] = "WEBHOOK_SEND_FAILED";
  ApiErrorCode2["AGREEMENT_NOT_FOUND"] = "AGREEMENT_NOT_FOUND";
  ApiErrorCode2["AGREEMENT_ALREADY_EXISTS"] = "AGREEMENT_ALREADY_EXISTS";
  ApiErrorCode2["AGREEMENT_MILESTONE_ALREADY_EXISTS"] = "AGREEMENT_MILESTONE_ALREADY_EXISTS";
  ApiErrorCode2["AGREEMENT_CREATED_EVENT_NOT_FOUND"] = "AGREEMENT_CREATED_EVENT_NOT_FOUND";
  ApiErrorCode2["AGREEMENT_MEDIATOR_NOT_FOUND"] = "AGREEMENT_MEDIATOR_NOT_FOUND";
  ApiErrorCode2["AGREEMENT_FAILED_TO_UPDATE_FILE"] = "AGREEMENT_FAILED_TO_UPDATE_FILE";
  ApiErrorCode2["AGREEMENT_PAYER_OR_RECEIVER_SHOULD_BE_SET"] = "AGREEMENT_PAYER_OR_RECEIVER_SHOULD_BE_SET";
  ApiErrorCode2["AGREEMENT_FILE_NOT_UPLOADED"] = "AGREEMENT_FILE_NOT_UPLOADED";
  ApiErrorCode2["AGREEMENT_NOT_CANCELABLE"] = "AGREEMENT_NOT_CANCELABLE";
  ApiErrorCode2["AGREEMENT_NOT_OPEN"] = "AGREEMENT_NOT_OPEN";
  ApiErrorCode2["AGREEMENT_PARTIES_NOT_DISTINCT"] = "AGREEMENT_PARTIES_NOT_DISTINCT";
  ApiErrorCode2["AGREEMENT_ARBITRATOR_INVALID"] = "AGREEMENT_ARBITRATOR_INVALID";
  ApiErrorCode2["AGREEMENT_ARBITRATOR_IS_PARTY"] = "AGREEMENT_ARBITRATOR_IS_PARTY";
  ApiErrorCode2["AGREEMENT_ARBITRATOR_LOCKED"] = "AGREEMENT_ARBITRATOR_LOCKED";
  ApiErrorCode2["AGREEMENT_PARTY_IS_ARBITRATOR"] = "AGREEMENT_PARTY_IS_ARBITRATOR";
  ApiErrorCode2["TENANT_USER_NOT_FOUND"] = "TENANT_USER_NOT_FOUND";
  ApiErrorCode2["DISPUTE_NOT_FOUND"] = "DISPUTE_NOT_FOUND";
  ApiErrorCode2["DISPUTE_AGREEMENT_NOT_SET"] = "DISPUTE_AGREEMENT_NOT_SET";
  ApiErrorCode2["DISPUTE_INVALID_STATUS"] = "DISPUTE_INVALID_STATUS";
  ApiErrorCode2["DISPUTE_INVALID_SIGNATURE"] = "DISPUTE_INVALID_SIGNATURE";
  ApiErrorCode2["DISPUTE_NOT_OPEN"] = "DISPUTE_NOT_OPEN";
  ApiErrorCode2["DISPUTE_NOT_MEDIATOR"] = "DISPUTE_NOT_MEDIATOR";
  ApiErrorCode2["AGREEMENT_INVALID_FILE_TYPE"] = "AGREEMENT_INVALID_FILE_TYPE";
  ApiErrorCode2["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
  ApiErrorCode2["DOCUMENT_NOT_OWNED"] = "DOCUMENT_NOT_OWNED";
  ApiErrorCode2["DOCUMENT_ANCHORED"] = "DOCUMENT_ANCHORED";
  ApiErrorCode2["DOCUMENT_EVIDENCE_LOCKED"] = "DOCUMENT_EVIDENCE_LOCKED";
  ApiErrorCode2["BLOCKCHAIN_MONITOR_CONTRACT_ADDRESS_REQUIRED"] = "BLOCKCHAIN_MONITOR_CONTRACT_ADDRESS_REQUIRED";
  ApiErrorCode2["ROOT_ADMIN_SIGNUP_NOT_ALLOWED"] = "ROOT_ADMIN_SIGNUP_NOT_ALLOWED";
  ApiErrorCode2["ROOT_ADMIN_NOT_FOUND"] = "ROOT_ADMIN_NOT_FOUND";
  ApiErrorCode2["CUSTOMER_NOT_FOUND"] = "CUSTOMER_NOT_FOUND";
  ApiErrorCode2["EXTERNAL_ACCOUNT_NOT_FOUND"] = "EXTERNAL_ACCOUNT_NOT_FOUND";
  ApiErrorCode2["EXTERNAL_ACCOUNT_ALREADY_EXISTS"] = "EXTERNAL_ACCOUNT_ALREADY_EXISTS";
  ApiErrorCode2["TRANSFER_ACCESS_DENIED"] = "TRANSFER_ACCESS_DENIED";
  ApiErrorCode2["TRANSFER_ACTION_NOT_PERMITTED"] = "TRANSFER_ACTION_NOT_PERMITTED";
  ApiErrorCode2["DEPOSIT_DESTINATION_HOLDER_ONLY"] = "DEPOSIT_DESTINATION_HOLDER_ONLY";
  ApiErrorCode2["PAYMENT_PROVIDER_DISABLED"] = "PAYMENT_PROVIDER_DISABLED";
  ApiErrorCode2["PROVIDER_CONFIG_NOT_FOUND"] = "PROVIDER_CONFIG_NOT_FOUND";
  ApiErrorCode2["PROVIDER_CONFIG_NOT_ACTIVE"] = "PROVIDER_CONFIG_NOT_ACTIVE";
  ApiErrorCode2["PROVIDER_CONFIG_ORGANISATION_ONLY"] = "PROVIDER_CONFIG_ORGANISATION_ONLY";
  ApiErrorCode2["DIRECT_PAYMENT_UNAVAILABLE"] = "DIRECT_PAYMENT_UNAVAILABLE";
  ApiErrorCode2["DIRECT_PAYMENT_NOT_DIRECT"] = "DIRECT_PAYMENT_NOT_DIRECT";
  ApiErrorCode2["DIRECT_PAYMENT_NOT_PENDING"] = "DIRECT_PAYMENT_NOT_PENDING";
  ApiErrorCode2["DIRECT_PAYMENT_NOT_PAYER"] = "DIRECT_PAYMENT_NOT_PAYER";
  ApiErrorCode2["DIRECT_PAYMENT_WRONG_SESSION_ACTION"] = "DIRECT_PAYMENT_WRONG_SESSION_ACTION";
  ApiErrorCode2["DIRECT_PAYMENT_MIXED_AGREEMENTS"] = "DIRECT_PAYMENT_MIXED_AGREEMENTS";
  ApiErrorCode2["DIRECT_PAYMENT_DOCUMENTS_REQUIRED"] = "DIRECT_PAYMENT_DOCUMENTS_REQUIRED";
  ApiErrorCode2["DIRECT_PAYMENT_TENANT_RECIPIENT_MISSING"] = "DIRECT_PAYMENT_TENANT_RECIPIENT_MISSING";
  ApiErrorCode2["DIRECT_PAYMENT_INVALID_FEE_RECIPIENT"] = "DIRECT_PAYMENT_INVALID_FEE_RECIPIENT";
  ApiErrorCode2["DIRECT_PAYMENT_ALREADY_SETTLED"] = "DIRECT_PAYMENT_ALREADY_SETTLED";
  ApiErrorCode2["DIRECT_PAYMENT_INVALID_AMOUNT"] = "DIRECT_PAYMENT_INVALID_AMOUNT";
  ApiErrorCode2["DIRECT_PAYMENT_FEES_EXCEED_AMOUNT"] = "DIRECT_PAYMENT_FEES_EXCEED_AMOUNT";
  ApiErrorCode2["DIRECT_PAYMENT_DIGEST_MISMATCH"] = "DIRECT_PAYMENT_DIGEST_MISMATCH";
  ApiErrorCode2["DIRECT_PAYMENT_DEPLOYMENT_MISMATCH"] = "DIRECT_PAYMENT_DEPLOYMENT_MISMATCH";
  ApiErrorCode2["DIRECT_PAYMENT_INSUFFICIENT_BALANCE"] = "DIRECT_PAYMENT_INSUFFICIENT_BALANCE";
  ApiErrorCode2["MILESTONE_ALREADY_EXISTS"] = "MILESTONE_ALREADY_EXISTS";
  ApiErrorCode2["MILESTONE_NOT_FOUND"] = "MILESTONE_NOT_FOUND";
  ApiErrorCode2["MILESTONE_NOT_FUNDED"] = "MILESTONE_NOT_FUNDED";
  ApiErrorCode2["MILESTONE_NOT_PENDING"] = "MILESTONE_NOT_PENDING";
  ApiErrorCode2["MILESTONE_COLLECT_FUNDS_FAILED"] = "MILESTONE_COLLECT_FUNDS_FAILED";
  ApiErrorCode2["MILESTONE_TOKEN_NOT_APPROVED"] = "MILESTONE_TOKEN_NOT_APPROVED";
  ApiErrorCode2["MILESTONE_TOKEN_NOT_ENOUGH_BALANCE"] = "MILESTONE_TOKEN_NOT_ENOUGH_BALANCE";
  ApiErrorCode2["MILESTONE_NOT_DEPLOYED"] = "MILESTONE_NOT_DEPLOYED";
  ApiErrorCode2["MILESTONE_APPROVE_FAILED"] = "MILESTONE_APPROVE_FAILED";
  ApiErrorCode2["MILESTONE_APPROVE_SIGNATURE_NOT_FOUND"] = "MILESTONE_APPROVE_SIGNATURE_NOT_FOUND";
  ApiErrorCode2["MILESTONE_NOT_APPROVED_BY_RECEIVER"] = "MILESTONE_NOT_APPROVED_BY_RECEIVER";
  ApiErrorCode2["MILESTONE_PAYMENT_SPLIT_ALREADY_EXISTS"] = "MILESTONE_PAYMENT_SPLIT_ALREADY_EXISTS";
  ApiErrorCode2["MILESTONE_PAYMENT_SPLIT_NOT_FOUND"] = "MILESTONE_PAYMENT_SPLIT_NOT_FOUND";
  ApiErrorCode2["MILESTONE_PAYMENT_SPLIT_ALREADY_APPROVED"] = "MILESTONE_PAYMENT_SPLIT_ALREADY_APPROVED";
  ApiErrorCode2["MILESTONE_PAYMENT_SPLIT_HAS_TO_BE_APPROVED_BY_THE_OTHER_PARTY"] = "MILESTONE_PAYMENT_SPLIT_HAS_TO_BE_APPROVED_BY_THE_OTHER_PARTY";
  ApiErrorCode2["MILESTONE_PAYMENT_SPLIT_HAS_TO_BE_REJECTED_BY_THE_OTHER_PARTY"] = "MILESTONE_PAYMENT_SPLIT_HAS_TO_BE_REJECTED_BY_THE_OTHER_PARTY";
  ApiErrorCode2["MILESTONE_INVALID_PAYMENT_SPLIT_SIGNATURE"] = "MILESTONE_INVALID_PAYMENT_SPLIT_SIGNATURE";
  ApiErrorCode2["MILESTONE_PAYMENT_SPLIT_DEADLINE_TOO_FAR"] = "MILESTONE_PAYMENT_SPLIT_DEADLINE_TOO_FAR";
  ApiErrorCode2["MILESTONE_ALREADY_RESOLVED"] = "MILESTONE_ALREADY_RESOLVED";
  ApiErrorCode2["MILESTONE_NOT_CANCELABLE"] = "MILESTONE_NOT_CANCELABLE";
  ApiErrorCode2["MILESTONE_ALREADY_IN_DISPUTE"] = "MILESTONE_ALREADY_IN_DISPUTE";
  ApiErrorCode2["MILESTONE_PAYMENT_IN_PROGRESS"] = "MILESTONE_PAYMENT_IN_PROGRESS";
  ApiErrorCode2["MILESTONE_NOT_ESCROW"] = "MILESTONE_NOT_ESCROW";
  ApiErrorCode2["DEPLOYMENT_DEPLOY_ESCROW_FAILED"] = "DEPLOYMENT_DEPLOY_ESCROW_FAILED";
  ApiErrorCode2["DEPLOYMENT_NOT_AUTHORIZED"] = "DEPLOYMENT_NOT_AUTHORIZED";
  ApiErrorCode2["WALLET_NOT_FOUND"] = "WALLET_NOT_FOUND";
  ApiErrorCode2["WALLET_NOT_DEPLOYED"] = "WALLET_NOT_DEPLOYED";
  ApiErrorCode2["WALLET_TARGET_NOT_FOUND"] = "WALLET_TARGET_NOT_FOUND";
  ApiErrorCode2["WALLET_TARGET_HAS_NO_CREDENTIAL"] = "WALLET_TARGET_HAS_NO_CREDENTIAL";
  ApiErrorCode2["WALLET_TARGET_ON_ANOTHER_WALLET"] = "WALLET_TARGET_ON_ANOTHER_WALLET";
  ApiErrorCode2["WALLET_TARGET_MISMATCH"] = "WALLET_TARGET_MISMATCH";
  ApiErrorCode2["WALLET_CEREMONY_CANCELLED"] = "WALLET_CEREMONY_CANCELLED";
  ApiErrorCode2["WALLET_CEREMONY_NOT_RECORDED"] = "WALLET_CEREMONY_NOT_RECORDED";
  ApiErrorCode2["WALLET_ALREADY_OWNER"] = "WALLET_ALREADY_OWNER";
  ApiErrorCode2["WALLET_NOT_AN_OWNER"] = "WALLET_NOT_AN_OWNER";
  ApiErrorCode2["WALLET_LAST_OWNER"] = "WALLET_LAST_OWNER";
  ApiErrorCode2["WALLET_NOT_PRIMARY_HOLDER"] = "WALLET_NOT_PRIMARY_HOLDER";
  return ApiErrorCode2;
})(ApiErrorCode || {});

// src/types/client-users.ts
var CLIENT_USER_KINDS = ["party", "arbitrator"];

// src/types/headers.ts
var CustomHeaders = /* @__PURE__ */ ((CustomHeaders2) => {
  CustomHeaders2["API_KEY"] = "x-api-key";
  CustomHeaders2["API_ID"] = "x-api-id";
  CustomHeaders2["APP_CONTEXT"] = "x-app-context-id";
  CustomHeaders2["WEBHOOK_VALIDATION_KEY"] = "x-webhook-validation-key";
  CustomHeaders2["REQUEST_ID"] = "x-request-id";
  return CustomHeaders2;
})(CustomHeaders || {});

// src/types/agreements.ts
var AgreementStatus = /* @__PURE__ */ ((AgreementStatus2) => {
  AgreementStatus2["PENDING"] = "pending";
  AgreementStatus2["ACTIVE"] = "active";
  AgreementStatus2["CANCELLED"] = "cancelled";
  AgreementStatus2["CLOSED"] = "closed";
  return AgreementStatus2;
})(AgreementStatus || {});
var ACCEPTED_AGREEMENT_FILE_TYPES = [
  "application/pdf",
  "image/*",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  "text/csv",
  "application/csv",
  "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.apple.numbers"
];

// src/types/documents.ts
var DOCUMENT_KINDS = ["document", "dispute_evidence"];
var EVIDENCE_PARTY_ROLES = ["payer", "receiver"];

// src/types/milestones.ts
var PaymentType = /* @__PURE__ */ ((PaymentType2) => {
  PaymentType2["ESCROW"] = "escrow";
  PaymentType2["DIRECT"] = "direct";
  return PaymentType2;
})(PaymentType || {});
var MilestoneStatus = /* @__PURE__ */ ((MilestoneStatus2) => {
  MilestoneStatus2["PENDING"] = "pending";
  MilestoneStatus2["DEPLOYED"] = "deployed";
  MilestoneStatus2["APPROVED"] = "approved";
  MilestoneStatus2["FUNDED"] = "funded";
  MilestoneStatus2["IN_DISPUTE"] = "in_dispute";
  MilestoneStatus2["CANCELLED"] = "cancelled";
  MilestoneStatus2["COMPLETED"] = "completed";
  MilestoneStatus2["RESOLVED"] = "resolved";
  MilestoneStatus2["PROPOSED_SPLIT"] = "proposed-split";
  return MilestoneStatus2;
})(MilestoneStatus || {});

// src/types/payment-split.ts
var PaymentSplitStatus = /* @__PURE__ */ ((PaymentSplitStatus2) => {
  PaymentSplitStatus2["PENDING"] = "pending";
  PaymentSplitStatus2["APPROVED"] = "approved";
  PaymentSplitStatus2["REJECTED"] = "rejected";
  return PaymentSplitStatus2;
})(PaymentSplitStatus || {});

// src/types/disputes.ts
var DisputeStatus = /* @__PURE__ */ ((DisputeStatus2) => {
  DisputeStatus2["PENDING"] = "pending";
  DisputeStatus2["CLOSED"] = "closed";
  return DisputeStatus2;
})(DisputeStatus || {});
var MAX_AWARD_NOTES_LENGTH = 4e3;

// src/types/chain.ts
var Chain = /* @__PURE__ */ ((Chain2) => {
  Chain2["HARDHAT"] = "hardhat";
  Chain2["BASE"] = "base";
  Chain2["BASE_SEPOLIA"] = "baseSepolia";
  return Chain2;
})(Chain || {});
var ChainErrorDescriptions = {
  // Authorization errors
  UnauthorizedCaller: "The caller is not authorized to perform this action",
  // Signature errors
  InvalidSignature: "The provided signature is invalid or does not match the expected signer",
  SignatureExpired: "The signature has expired and is no longer valid",
  // Amount validation errors
  InvalidSplitAmounts: "The split amounts do not equal the total recognized balance",
  ZeroAmount: "The amount cannot be zero",
  FeesExceedAmount: "The calculated fees exceed the deposit amount",
  NoFunds: "No funds are available in the escrow",
  // Configuration errors
  InvalidConfig: "The escrow configuration is invalid (zero addresses or missing required fields)",
  PartiesMustDiffer: "Payer and receiver cannot be the same address",
  DuplicateMediator: "Duplicate mediator addresses are not allowed",
  InvalidMediator: "One or more mediator addresses are invalid (zero address or same as parties)",
  InvalidFeeRate: "The fee rate is invalid (zero or too high)",
  FeesTooHigh: "The total fee rate exceeds the maximum allowed (100%)",
  // State errors
  InvalidState: "The escrow is not in the required state for this operation",
  // DirectPayments errors. Each names one condition: a single shared error told the payer
  // nothing about which field was wrong, and — being shared with Escrow — described a direct
  // payment's failure as an escrow misconfiguration.
  PaymentAlreadyExecuted: "This milestone has already been paid.",
  PaymentRevoked: "These payment terms were cancelled. Reload the page to get fresh terms.",
  AuthorizationExpired: "The payment terms expired. Reload the page to get fresh terms.",
  DeadlineBeforeIssuedAt: "The payment terms are not valid. Reload the page to get fresh terms.",
  DeadlineTooFar: "The payment terms are not valid. Reload the page to get fresh terms.",
  RevocationExpired: "The cancellation request expired before it was submitted.",
  InvalidAuthorizerSignature: "The payment terms could not be verified.",
  FeeSumMismatch: "The payment terms are inconsistent. Contact support.",
  AmountBreakdownMismatch: "The payment terms are inconsistent. Contact support.",
  // The contract checks the sending account, not a person: any owner of the payer's
  // wallet sends from that account, so the refusal is about the wallet.
  UnauthorizedPayer: "This payment can only be sent from the payer\u2019s wallet.",
  TooManyFees: "The payment could not be completed. Contact support.",
  InvalidFeeBeneficiary: "The payment could not be completed. Contact support.",
  ForbiddenFeeBeneficiary: "A fee recipient address is not valid. Contact support.",
  UnexpectedTransferAmount: "The payment could not be completed. Contact support.",
  UnbalancedSettlement: "The payment could not be completed. Contact support.",
  ZeroAuthorizer: "The payment contract is misconfigured. Contact support.",
  ZeroToken: "The payment token is missing from the terms. Contact support.",
  ZeroReceiver: "The payment recipient is missing from the terms. Contact support.",
  ForbiddenReceiver: "The payment recipient address is not valid. Contact support.",
  ZeroGrossAmount: "The payment amount cannot be zero.",
  // External dependency errors
  ERC20InsufficientBalance: "There are not enough funds in your wallet to make this payment. Add funds and try again.",
  ERC20InsufficientAllowance: "The payment was not approved for the full amount. Reload the page to get fresh terms.",
  ERC20InvalidReceiver: "Invalid token receiver address",
  ERC20InvalidSender: "Invalid token sender address",
  ERC20InvalidApprover: "Invalid token approver address",
  ERC20InvalidSpender: "Invalid token spender address",
  SafeERC20FailedOperation: "The token transfer failed. Contact support.",
  OwnableUnauthorizedAccount: "Only the contract owner can perform this action",
  OwnableInvalidOwner: "Invalid owner address provided",
  ReentrancyGuardReentrantCall: "Reentrant call detected and blocked",
  // System-level errors
  OutOfGas: "Transaction ran out of gas",
  GasLimitExceeded: "Transaction exceeds the block gas limit",
  TransactionUnderpriced: "Gas price is too low for the network",
  NonceError: "Transaction nonce is incorrect",
  InsufficientFundsForGas: "Insufficient funds to pay for gas"
};

// src/types/invites.ts
var InviteStatus = /* @__PURE__ */ ((InviteStatus2) => {
  InviteStatus2["PENDING"] = "pending";
  InviteStatus2["ACCEPTED"] = "accepted";
  InviteStatus2["EXPIRED"] = "expired";
  return InviteStatus2;
})(InviteStatus || {});

// src/types/tenant-users.ts
var TenantUserRole = /* @__PURE__ */ ((TenantUserRole2) => {
  TenantUserRole2["ADMIN"] = "admin";
  return TenantUserRole2;
})(TenantUserRole || {});

// src/types/transactions.ts
var TransactionStatus = /* @__PURE__ */ ((TransactionStatus2) => {
  TransactionStatus2["PENDING"] = "pending";
  TransactionStatus2["COMPLETED"] = "completed";
  TransactionStatus2["FAILED"] = "failed";
  TransactionStatus2["REFUNDED"] = "refunded";
  return TransactionStatus2;
})(TransactionStatus || {});
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["REFUND"] = "refund";
  TransactionType2["FUND"] = "fund";
  TransactionType2["PAY_MILESTONE"] = "pay_milestone";
  TransactionType2["PAY_RECEIVER"] = "pay_receiver";
  TransactionType2["PAY_PLATFORM_FEE"] = "pay_platform_fee";
  TransactionType2["PAY_TENANT_FEE"] = "pay_tenant_fee";
  TransactionType2["WITHDRAW"] = "withdraw";
  TransactionType2["DEPOSIT"] = "deposit";
  return TransactionType2;
})(TransactionType || {});

// src/types/offramp.ts
var AccountType = /* @__PURE__ */ ((AccountType2) => {
  AccountType2["IBAN"] = "iban";
  AccountType2["US"] = "us";
  return AccountType2;
})(AccountType || {});
var AccountOwnerType = /* @__PURE__ */ ((AccountOwnerType2) => {
  AccountOwnerType2["INDIVIDUAL"] = "individual";
  AccountOwnerType2["BUSINESS"] = "business";
  return AccountOwnerType2;
})(AccountOwnerType || {});
var CheckingOrSavings = /* @__PURE__ */ ((CheckingOrSavings2) => {
  CheckingOrSavings2["CHECKING"] = "checking";
  CheckingOrSavings2["SAVINGS"] = "savings";
  return CheckingOrSavings2;
})(CheckingOrSavings || {});

// src/types/transfers.ts
var TransferCurrency = /* @__PURE__ */ ((TransferCurrency2) => {
  TransferCurrency2["USD"] = "usd";
  TransferCurrency2["EUR"] = "eur";
  TransferCurrency2["MXN"] = "mxn";
  TransferCurrency2["DAI"] = "dai";
  TransferCurrency2["USDC"] = "usdc";
  TransferCurrency2["USDT"] = "usdt";
  TransferCurrency2["USDB"] = "usdb";
  TransferCurrency2["PYUSD"] = "pyusd";
  TransferCurrency2["EURC"] = "eurc";
  return TransferCurrency2;
})(TransferCurrency || {});
var PaymentRail = /* @__PURE__ */ ((PaymentRail2) => {
  PaymentRail2["ACH"] = "ach";
  PaymentRail2["WIRE"] = "wire";
  PaymentRail2["ACH_PUSH"] = "ach_push";
  PaymentRail2["ACH_SAME_DAY"] = "ach_sameday";
  PaymentRail2["SWIFT"] = "swift";
  PaymentRail2["BRIDGE_WALLET"] = "bridge_wallet";
  PaymentRail2["BASE"] = "base";
  PaymentRail2["SEPA"] = "sepa";
  return PaymentRail2;
})(PaymentRail || {});
var TransferState = /* @__PURE__ */ ((TransferState2) => {
  TransferState2["AWAITING_FUNDS"] = "awaiting_funds";
  TransferState2["IN_REVIEW"] = "in_review";
  TransferState2["FUNDS_RECEIVED"] = "funds_received";
  TransferState2["PAYMENT_SUBMITTED"] = "payment_submitted";
  TransferState2["PAYMENT_PROCESSED"] = "payment_processed";
  TransferState2["UNDELIVERABLE"] = "undeliverable";
  TransferState2["RETURNED"] = "returned";
  TransferState2["REFUNDED"] = "refunded";
  TransferState2["CANCELED"] = "canceled";
  TransferState2["ERROR"] = "error";
  return TransferState2;
})(TransferState || {});

// src/types/root-admins.ts
var RootAdminsSignupStatus = /* @__PURE__ */ ((RootAdminsSignupStatus2) => {
  RootAdminsSignupStatus2["AVAILABLE"] = "available";
  RootAdminsSignupStatus2["INVITE_ONLY"] = "invite-only";
  return RootAdminsSignupStatus2;
})(RootAdminsSignupStatus || {});

// src/types/currency.ts
var SupportedCurrencies = /* @__PURE__ */ ((SupportedCurrencies2) => {
  SupportedCurrencies2["USD"] = "usd";
  SupportedCurrencies2["EUR"] = "eur";
  SupportedCurrencies2["MXN"] = "mxn";
  return SupportedCurrencies2;
})(SupportedCurrencies || {});

// src/types/addresses.ts
var ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
function parseEvmAddress(value) {
  if (typeof value !== "string") {
    return null;
  }
  const raw = value.trim().toLowerCase();
  if (!/^0x[0-9a-f]{40}$/.test(raw)) {
    return null;
  }
  if (raw === ZERO_ADDRESS) {
    return null;
  }
  return raw;
}

// src/types/payment-providers.ts
var ProviderName = /* @__PURE__ */ ((ProviderName2) => {
  ProviderName2["BRIDGE"] = "bridge";
  ProviderName2["MOCK"] = "mock";
  return ProviderName2;
})(ProviderName || {});
var CANONICAL_EVENT_TYPES = [
  "customer.kyc.updated",
  "funding.pending",
  "funding.received",
  "funding.completed",
  "payout.pending",
  "payout.processing",
  "payout.completed",
  "transaction.failed",
  "transaction.refunded"
];
var ProviderConfigStatus = /* @__PURE__ */ ((ProviderConfigStatus2) => {
  ProviderConfigStatus2["ACTIVE"] = "active";
  ProviderConfigStatus2["DISABLED"] = "disabled";
  ProviderConfigStatus2["PENDING"] = "pending";
  return ProviderConfigStatus2;
})(ProviderConfigStatus || {});
var MAX_DEVELOPER_FEE_PERCENT = 10;
var MAX_DEVELOPER_FEE_DECIMALS = 5;
function parseDeveloperFeePercent(value) {
  if (typeof value !== "string" && typeof value !== "number") {
    return null;
  }
  const raw = String(value).trim();
  if (!/^\d+(\.\d+)?$/.test(raw)) {
    return null;
  }
  const decimals = raw.split(".")[1]?.length ?? 0;
  if (decimals > MAX_DEVELOPER_FEE_DECIMALS) {
    return null;
  }
  const numeric = Number(raw);
  if (!Number.isFinite(numeric) || numeric < 0 || numeric > MAX_DEVELOPER_FEE_PERCENT) {
    return null;
  }
  return raw;
}

// src/utils/parse-public-key-credential-to-dto.ts
import { utils } from "@passwordless-id/webauthn";
function parsePublicKeyCredentialToAuthenticationDto(raw) {
  if (raw.type != "public-key") {
    throw new Error("Unexpected credential type!");
  }
  const response = raw.response;
  return {
    id: raw.id,
    rawId: utils.toBase64url(raw.rawId),
    type: raw.type,
    authenticatorAttachment: raw.authenticatorAttachment,
    clientExtensionResults: raw.getClientExtensionResults(),
    response: {
      authenticatorData: utils.toBase64url(response.authenticatorData),
      clientDataJSON: utils.toBase64url(response.clientDataJSON),
      signature: utils.toBase64url(response.signature),
      userHandle: response.userHandle ? utils.toBase64url(response.userHandle) : void 0
    }
  };
}
function parsePublicKeyCredentialToRegistrationDto(raw) {
  if (raw.type != "public-key") {
    throw new Error("Unexpected credential type!");
  }
  const response = raw.response;
  const publicKey = response.getPublicKey();
  if (!publicKey)
    throw new Error("Non-compliant browser or authenticator!");
  return {
    id: raw.id,
    rawId: utils.toBase64url(raw.rawId),
    type: raw.type,
    authenticatorAttachment: raw.authenticatorAttachment,
    clientExtensionResults: raw.getClientExtensionResults(),
    response: {
      attestationObject: utils.toBase64url(response.attestationObject),
      authenticatorData: utils.toBase64url(response.getAuthenticatorData()),
      clientDataJSON: utils.toBase64url(response.clientDataJSON),
      publicKey: utils.toBase64url(publicKey),
      publicKeyAlgorithm: response.getPublicKeyAlgorithm(),
      transports: response.getTransports()
    },
    user: {
      name: ""
    }
  };
}

// src/utils/base64-url.ts
function parseBase64url(txt) {
  txt = txt.replace(/-/g, "+").replace(/_/g, "/");
  while (txt.length % 4) {
    txt += "=";
  }
  const binaryString = atob(txt);
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}
function toBase64url(buffer) {
  const uint8Array = new Uint8Array(buffer);
  let binaryString = "";
  for (let i = 0; i < uint8Array.length; i++) {
    binaryString += String.fromCharCode(uint8Array[i]);
  }
  const txt = btoa(binaryString);
  return txt.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

// src/utils/split.ts
var calculatePaymentSplitAmounts = (amount, receiverPercentage) => {
  const scaledPercentage = Math.round(receiverPercentage * 100);
  const receiverAmount = amount * BigInt(scaledPercentage) / BigInt(1e4);
  const payerAmount = amount - receiverAmount;
  return {
    receiverAmount,
    payerAmount
  };
};
var tokenUnitsPerCent = (decimals) => BigInt(10 ** Math.max(decimals - 2, 0));
function awardSplitAmounts(total, receiverPercentage, decimals) {
  const exact = calculatePaymentSplitAmounts(total, receiverPercentage);
  const unit = tokenUnitsPerCent(decimals);
  const receiverAmount = exact.payerAmount === BigInt(0) ? total : exact.receiverAmount / unit * unit;
  return { receiverAmount, payerAmount: total - receiverAmount };
}

// src/utils/direct-payment-id.ts
import { keccak256, stringToHex } from "viem";
var directPaymentIdFor = (milestoneId) => keccak256(stringToHex(`portafino:direct-payment:${milestoneId}`));
export {
  ACCEPTED_AGREEMENT_FILE_TYPES,
  AccountOwnerType,
  AccountType,
  AgreementStatus,
  ApiErrorCode,
  CANONICAL_EVENT_TYPES,
  CLIENT_USER_KINDS,
  Chain,
  ChainErrorDescriptions,
  CheckingOrSavings,
  CustomHeaders,
  DOCUMENT_KINDS,
  DisputeStatus,
  EVIDENCE_PARTY_ROLES,
  InviteStatus,
  MAX_AWARD_NOTES_LENGTH,
  MAX_DEVELOPER_FEE_DECIMALS,
  MAX_DEVELOPER_FEE_PERCENT,
  MilestoneStatus,
  PasskeyResponseType,
  PaymentRail,
  PaymentSplitStatus,
  PaymentType,
  ProviderConfigStatus,
  ProviderName,
  RootAdminsSignupStatus,
  SessionActions,
  SessionUserType,
  SupportedCurrencies,
  TenantUserRole,
  TransactionStatus,
  TransactionType,
  TransferCurrency,
  TransferState,
  awardSplitAmounts,
  calculatePaymentSplitAmounts,
  directPaymentIdFor,
  parseBase64url,
  parseDeveloperFeePercent,
  parseEvmAddress,
  parsePublicKeyCredentialToAuthenticationDto,
  parsePublicKeyCredentialToRegistrationDto,
  toBase64url,
  tokenUnitsPerCent
};
//# sourceMappingURL=index.mjs.map